import axios from 'axios';

const baseUrl = 'https://api.nexton.ag/put-planting-data';

export default function putPlantingData(data) {
  return axios.put(
    baseUrl,
    data
  )
}
